var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import moment from 'moment';
import { isEqual } from 'lodash';
import { default as AntDatePicker } from 'antd/lib/date-picker';
import { globalConfig } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';

var DatePicker = function (_super) {
  __extends(DatePicker, _super);

  function DatePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.format = globalConfig.get('format.date') || '';
    _this.onChange = services.pickerHelper.onChange.bind(_this);
    _this.disabledDate = services.pickerHelper.disabledDate.bind(_this);
    return _this;
  }

  DatePicker.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  DatePicker.prototype.render = function () {
    var format = this.format;
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        value = _a.value,
        _b = _a.format,
        renderFormat = _b === void 0 ? format : _b,
        _c = _a.placeholder,
        placeholder = _c === void 0 ? services.language.getText('common.pleaseSelect') : _c,
        disabled = _a.disabled,
        allowClear = _a.allowClear;

    if (value) {
      value = moment(value, format);
    }

    var props = {
      className: className,
      style: style,
      value: value,
      format: renderFormat,
      placeholder: placeholder,
      disabled: disabled,
      allowClear: allowClear,
      showTime: false,
      onChange: this.onChange,
      disabledDate: this.disabledDate
    };
    return React.createElement(AntDatePicker, __assign({}, props));
  };

  return DatePicker;
}(Component);

export { DatePicker };